import { Instagram, Facebook, Youtube, Mail } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
  { label: "Eventi", href: "#eventi" },
  { label: "Chi Siamo", href: "#chi-siamo" },
  { label: "Galleria", href: "#galleria" },
  { label: "Regolamento", href: "#regolamento" },
  { label: "Contatti", href: "#contatti" }];


  const socialLinks = [
  { icon: Instagram, href: "https://www.instagram.com/ghostdivisionsat?igsh=MThpa3diaTF6bGNlbA==", label: "Instagram" },
  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=100054423942255", label: "Facebook" },
  { icon: Youtube, href: "#", label: "YouTube" },
  { icon: Mail, href: "mailto:gdivision@outlook.it", label: "Email" }];


  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="footer" className="bg-tactical-bg border-t border-tactical-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/logo.png"
                alt="Ghost Division Logo"
                className="w-14 h-14 object-contain" />

              <span className="font-heading font-bold text-xl tracking-wider !text-[#444444]">
                GHOST<span className="text-tactical-primary">DIVISION A.S.D.</span>
              </span>
            </div>
            <p className="font-body text-tactical-text-muted mb-6">Associazione Sportiva Dilettantistica di Softair. Passione, tattica e spirito di squadra dal 2016.


            </p>
            <div className="font-mono text-xs text-tactical-text-muted">
              <p>C.F.: 92148500900</p>
              <p>Affiliata F.I.G.T. - A.N.S.W.G.</p>
              <p>Affiliata C.S.E.N Ente di Promozione Sportiva</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg tracking-wider text-tactical-text uppercase mb-6">
              Link Rapidi
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) =>
              <li key={link.href}>
                  <button
                  onClick={() => scrollToSection(link.href)}
                  className="font-body text-tactical-text-muted hover:text-tactical-primary transition-colors">

                    {link.label}
                  </button>
                </li>
              )}
            </ul>
          </div>

          {/* Social & Newsletter */}
          <div>
            <h4 className="font-heading font-bold text-lg tracking-wider text-tactical-text uppercase mb-6">
              Seguici
            </h4>
            <div className="flex gap-4 mb-8">
              {socialLinks.map((social) => (
              <a
                target="_blank"
                rel="noopener noreferrer"
                key={social.label}
                href={social.href}
                aria-label={social.label}
                data-testid={`social-${social.label.toLowerCase()}`}
                className="w-10 h-10 bg-tactical-surface border border-tactical-border flex items-center justify-center hover:border-tactical-primary hover:text-tactical-primary transition-colors text-tactical-text-muted">

                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
            
            <p className="font-body text-sm text-tactical-text-muted">
              Segui i nostri canali social per aggiornamenti su eventi, 
              foto e video dalle nostre missioni.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-tactical-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-mono text-xs text-tactical-text-muted">
            © {currentYear} Ghost Division A.S.D. Tutti i diritti riservati.
          </p>
          <div className="flex gap-6">
            <a href="/privacy-policy.pdf" target="_blank" rel="noopener noreferrer" className="font-mono text-xs text-tactical-text-muted hover:text-tactical-primary transition-colors">
              Privacy Policy
            </a>
            <a href="/cookie-policy.pdf" target="_blank" rel="noopener noreferrer" className="font-mono text-xs text-tactical-text-muted hover:text-tactical-primary transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>);

};